/* eslint-disable import/no-cycle */
export * from './core';
export * from './to_locale_string';
/**
 * Check if a formatting number with unit is supported
 * @public
 * @param unit unit to check
 */
export function isUnitSupported(unit) {
    try {
        new Intl.NumberFormat(undefined, {
            style: 'unit',
            // @ts-ignore
            unit: unit,
        });
    }
    catch (e) {
        return false;
    }
    return true;
}
//# sourceMappingURL=index.js.map